module.exports = __webpack_public_path__ + "static/media/notmilk-banner.e3fbfc60.png";